export const environment = {
  production: true,
  apiUrl: 'https://tech-resume.fly.dev/api',
};
